import './service-hub.scss';
// import { getOffset, smoothScrollTo } from '../../js/helper';

class ServiceHub {
    constructor (element) {
        this.$serviceHub = element;
        this.$serviceContents = this.$serviceHub.querySelector('[data-service-hub="contents"]');
        this.$$categoryContents = this.$serviceHub.querySelectorAll('div[data-service-hub-category]');
        this.$$categoryInputs = this.$serviceHub.querySelectorAll('input[data-service-hub-category]');
        this.activeContent = this.$serviceContents.querySelector('div[data-service-hub-category].is--active')?.getAttribute('data-service-hub-category');
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$$categoryInputs.forEach((input) => {
            input.addEventListener('change', () => {
                if (input.checked) {
                    const $lastActive = this.$serviceHub.querySelector('input[data-service-hub-category]:checked:not([id="' + input.getAttribute('id') + '"])');
                    const $lastActiveMobile = this.$serviceContents.querySelector('.service-hub__category-label.is--active');
                    const $newActiveLabelMobile = this.$serviceContents.querySelector('label[for="' + input.getAttribute('id') + '"]');

                    if ($lastActive) {
                        $lastActive.checked = false;

                        if ($lastActiveMobile) {
                            $lastActiveMobile.classList.remove('is--active');
                        }
                    }

                    if ($newActiveLabelMobile) {
                        $newActiveLabelMobile.classList.add('is--active');
                    }

                    this.setContent(input.getAttribute('data-service-hub-category'));
                }
            });
        });
    }

    setContent (category) {
        if (category) {
            if (this.activeContent !== '') {
                const $activeContent = this.$serviceContents.querySelector('[data-service-hub-category].is--active');

                if ($activeContent) {
                    $activeContent.classList.add('is--hidden');
                    setTimeout(() => {
                        $activeContent.classList.remove('is--active');
                        $activeContent.classList.remove('is--hidden');
                    }, 250);
                }
            }

            const $content = this.$serviceContents.querySelector('[data-service-hub-category="' + category + '"]');

            setTimeout(() => {
                $content.classList.add('is--active');
            }, 250);
        }
    }
}

export { ServiceHub };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $serviceHub = $context.querySelector('[data-service-hub="root"]');

        if ($serviceHub) {
            const $ServiceHub = new ServiceHub($serviceHub);
            $ServiceHub.initialize();
        }
    }
});
